export const VARIANT_TYPE = 'variant'
export const BUNDLE_TYPE = 'bundle'

export const FILTER_NAME = 'sale_order'

export const SKIP_PROCESS_KEYS = {
  PICKLIST: 'skipPicking',
  PACKING: 'skipPacking'
}
